import React, { Component } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../../../components/common';
import formatPeriodicity from '../../../lib/TripicaPeriodicityFormatter';
import FormatService from '../../../lib/format';
import I18n from '../../../lib/i18n';
import { formatValue } from '../../../lib/usage-formatters';
import theme from '../../../theme-config';

class PlanUniqueOffer extends Component<Props> {
  styles = getStyles();

  componentDidMount() {
    const filteredCreditableOptions = this.props.creditableOptions?.map(creditableOption => {
      return creditableOption.filter(option => {
        let isOK = true;
        option?.characteristics?.forEach(charac => {
          if (charac.name === 'ORDER_CATEGORY_RESTRICTED') {
            if (!charac?.value.includes(this.props.orderType)) {
              isOK = false;
            }
          }
        });
        return isOK;
      });
    });
    filteredCreditableOptions.forEach(creditableOption => {
      this.props.addOptionToNewOffer(creditableOption[0]);
    });
  }

  computeUniqueOfferValues = (creditableOptions: Object[]) => {
    let uniqueOfferPrice = 0;
    let uniqueOfferPeriodicity = '';
    let uniqueOfferDataCredit = '';
    let uniqueOfferDataEuropeCredit = '';

    creditableOptions.forEach(options => {
      uniqueOfferPrice += options[0].price?.taxIncludedAmount;
      if (options[0].type === 'DATA') {
        const dataOption = options[0];
        uniqueOfferDataCredit = dataOption.characteristics.filter(c => c.name === 'DATA_CREDIT')[0].value;
        uniqueOfferDataEuropeCredit = dataOption.characteristics.filter(c => c.name === 'DATA_AND_EUROPE_CREDIT')[0]
          .value;
        uniqueOfferPeriodicity = dataOption.periodicity;
      }
    });

    return {
      price: uniqueOfferPrice,
      dataCredit: uniqueOfferDataCredit,
      europeDataCredit: uniqueOfferDataEuropeCredit,
      periodicity: uniqueOfferPeriodicity,
    };
  };
  render() {
    const { styles } = this;
    const uniqueOfferValues = this.computeUniqueOfferValues(this.props.creditableOptions);
    return (
      <View style={this.props.isActivation ? styles.parentContainerWithMarginBottom : styles.parentContainer}>
        <Text style={styles.title}>{I18n.t(`ChangePlan.PlanUniqueOffer.title`)}</Text>
        <Text style={styles.subtitle}>{I18n.t(`ChangePlan.PlanUniqueOffer.subtitle`)}</Text>
        <View style={styles.optionsContainer}>
          <View style={styles.optionPriceContainer}>
            <Text style={styles.optionValueText}>
              {FormatService.formatCentsToCurrency(uniqueOfferValues.price, true)}
            </Text>
            <Text style={styles.suffixText}>{formatPeriodicity(uniqueOfferValues.periodicity)}</Text>
          </View>
          <View style={styles.optionDataContainer}>
            <Text style={styles.optionValueText}>{formatValue(uniqueOfferValues.dataCredit, 'VOLUME')}</Text>
            <Text style={styles.suffixText}></Text>
          </View>
        </View>

        <View style={styles.itemParent}>
          <View style={styles.itemChildContainerLeft}>
            <Icon style={styles.itemIcon} name={'data'} size={30} color={'red'} />
          </View>
          <View style={styles.itemChildContainerRight}>
            <Text style={styles.itemText}>
              {I18n.t(`ChangePlan.PlanUniqueOffer.dataAmount`, {
                value: formatValue(uniqueOfferValues.dataCredit, 'VOLUME'),
              })}
            </Text>
          </View>
        </View>

        <View style={styles.itemParent}>
          <View style={styles.itemChildContainerLeft}>
            <Icon style={styles.itemIcon} name={'data-plane'} size={30} color={'red'} />
          </View>
          <View style={styles.itemChildContainerRight}>
            <Text style={styles.itemText}>
              {I18n.t(`ChangePlan.PlanUniqueOffer.dataAmount`, {
                value: formatValue(uniqueOfferValues.europeDataCredit, 'VOLUME'),
              })}
            </Text>
            <Text style={styles.itemSubtitleText}>{I18n.t(`ChangePlan.PlanUniqueOffer.fromEurope`)}</Text>
          </View>
        </View>

        <View style={styles.itemParent}>
          <View style={styles.itemChildContainerLeft}>
            <Icon style={styles.itemIcon} name={'phone-sms'} size={30} color={'red'} />
          </View>
          <View style={styles.itemChildContainerRight}>
            <Text style={styles.itemText}>{I18n.t(`ChangePlan.PlanUniqueOffer.unlimitedVoiceSms`)}</Text>
            <Text style={styles.itemSubtitleText}>{I18n.t(`ChangePlan.PlanUniqueOffer.fromLocalZoneAndEurope`)}</Text>
          </View>
        </View>
      </View>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    parentContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    parentContainerWithMarginBottom: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 80,
    },
    title: {
      alignSelf: 'center',
      color: theme.secondaryColor,
      fontSize: 20,
      fontWeight: '800',
      marginTop: 5,
    },
    subtitle: {
      alignSelf: 'center',
      color: theme.secondaryColor,
      fontSize: 13,
      marginTop: 5,
    },
    optionsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      height: 70,
      marginTop: 40,
    },
    optionPriceContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      width: 130,
      marginRight: 6,
      backgroundColor: theme.primaryColor,
    },
    optionDataContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      width: 130,
      marginLeft: 6,
      backgroundColor: theme.secondaryColor,
    },
    optionValueText: {
      textAlignVertical: 'center',
      color: 'white',
      fontWeight: '800',
      fontSize: 20,
      ...Platform.select({
        ios: {
          lineHeight: 65,
        },
        web: {
          lineHeight: 65,
        },
        android: {},
      }),
    },
    suffixText: {
      textAlignVertical: 'center',
      color: 'white',
      fontSize: 14,
      ...Platform.select({
        ios: {
          lineHeight: 65,
        },
        web: {
          lineHeight: 65,
        },
        android: {},
      }),
    },
    itemParent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: 25,
      ...Platform.select({
        ios: {
          marginLeft: 60,
          marginRight: 60,
        },
        web: {
          marginLeft: 60,
          marginRight: 60,
        },
        android: {
          marginLeft: 70,
          marginRight: 70,
        },
      }),
    },
    itemChildContainerLeft: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      flex: 2,
    },
    itemChildContainerRight: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      flex: 8,
      paddingLeft: 10,
    },
    itemIcon: {
      alignSelf: 'center',
      flex: 1,
    },
    itemText: {
      textAlignVertical: 'center',
      flex: 1,
      color: theme.secondaryColor,
      fontSize: 15,
      fontWeight: '800',
    },
    itemSubtitleText: {
      textAlignVertical: 'center',
      flex: 1,
      color: theme.secondaryColor,
      fontSize: 12,
    },
  });
}

export type Props = {
  creditableOptions: Object[][],
  priceKey: string,
  withZoneValidity?: Boolean,
  isActivation: Boolean,
  orderType?: string,
  isChangingPlanDuringTurnBackOn?: boolean,
  totalPrice: number,
  periodicity: string,
};

export default PlanUniqueOffer;
